import classNames from 'classnames';
import { IconCircle } from 'featherico';
import Button from '../Button';
import styles from './style.m.less';

export default function ReadUnreadToggler({ isRead, onClick }) {
    const tooltip = isRead ? 'Mark as unread' : 'Mark as read';
    return (
        <Button
            kind="PLAIN"
            data-tooltip={tooltip}
            data-tooltip-options="left oneline"
            className={styles.button}
            onClick={onClick}
            eventTracking={{ category: 'notifications', action: 'mark', label: isRead ? 'as unread' : 'as read' }}
        >
            <IconCircle
                className={classNames(styles.default, { [styles.unread]: !isRead })}
                customStyle={{ width: '0.9em', height: 'auto' }}
            />
        </Button>
    );
}
